import React, { useEffect, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Card, Steps, Tooltip, Collapse, Modal, Switch } from "antd";
import LoadingArea from "../../components/LoadingArea";
import axios from "axios";
import BASE from "../../config";
import ReactLoading from "react-loading";
import { SearchOutlined, EditOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { Table } from "antd";
import { DatePicker, Tag } from "antd";
import moment from "moment";
import { formatDateDDMMYYYY } from "../../utils/commonFunctions";
import useAxios from "../../hooks/useAxios";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";

const { RangePicker } = DatePicker;

const AIService = () => {
  const api = useAxios();
  const [open, setOpen] = useState(false);
  const [disableEdit, setDisableEdit] = useState(true);
  const [load, setLoad] = useState(false);
  const [disable, setDisable] = useState(true);
  const [editableData, setEditableData] = useState({
    _id: "",
    name: "",
    start: "",
    end: "",
    active: "",
  });
  const oneMonthLater = new Date();
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 2);
  const [active, setActive] = useState(null);
  const [serviceName, setServiceName] = useState("");
  const [tableData, setTableData] = useState([]);
  const [defaultDate, setDefaultDate] = useState([
    moment(new Date()).format("YYYY-MM-DD"),
    moment(new Date(oneMonthLater)).format("YYYY-MM-DD"),
  ]);
  const [canViewAiService, setCanViewAiService] = useState(false);
  const [canToggleAiService, setCanToggleAiService] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const [viewAllowed, toggleAllowed] = await Promise.all([
        checkPermission(userRole, "ai_service_module", "view_ai_service"),
        checkPermission(userRole, "ai_service_module", "toggle_ai_service"),
      ]);
      setCanViewAiService(viewAllowed);
      setCanToggleAiService(toggleAllowed);
    } catch (error) {
      console.error("Permission check failed for AI Service Module:", error);
    }
  };

  const columns = [
    // {
    //   title: "S No.",
    //   dataIndex: "sno",
    //   key: "sno",
    // },
    {
      title: "Service Name",
      dataIndex: "name",
      key: "name",
      // sorter: (a, b) => a.name > b.name,
      // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
      //   return (
      //     <>
      //       <Input
      //         autoFocus
      //         placeholder="Type text here"
      //         value={selectedKeys[0]}
      //         onChange={(e) => {
      //           setSelectedKeys(e.target.value ? [e.target.value] : []);
      //           confirm({ closeDropdown: false });
      //         }}
      //         onBlur={() => {
      //           confirm();
      //         }}
      //       ></Input>
      //     </>
      //   );
      // },
      // filterIcon: () => {
      //   return <SearchOutlined />;
      // },
      // onFilter: (value, record) => {
      //   return record.name.toLowerCase().includes(value.toLowerCase());
      // },
    },
    // {
    //   title: "Start Date",
    //   dataIndex: "start_date",
    //   key: "start_date",
    //   sorter: (a, b) => a.start_date > b.start_date,
    //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
    //     return (
    //       <>
    //         <Input
    //           autoFocus
    //           placeholder="Type text here"
    //           value={selectedKeys[0]}
    //           onChange={(e) => {
    //             setSelectedKeys(e.target.value ? [e.target.value] : []);
    //             confirm({ closeDropdown: false });
    //           }}
    //           onBlur={() => {
    //             confirm();
    //           }}
    //         ></Input>
    //       </>
    //     );
    //   },
    //   filterIcon: () => {
    //     return <SearchOutlined />;
    //   },
    //   onFilter: (value, record) => {
    //     return record.start_date.toLowerCase().includes(value.toLowerCase());
    //   },
    // },
    // {
    //   title: "End Date",
    //   dataIndex: "end_date",
    //   key: "end_date",
    //   sorter: (a, b) => a.end_date > b.end_date,
    //   filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
    //     return (
    //       <>
    //         <Input
    //           autoFocus
    //           placeholder="Type text here"
    //           value={selectedKeys[0]}
    //           onChange={(e) => {
    //             setSelectedKeys(e.target.value ? [e.target.value] : []);
    //             confirm({ closeDropdown: false });
    //           }}
    //           onBlur={() => {
    //             confirm();
    //           }}
    //         ></Input>
    //       </>
    //     );
    //   },
    //   filterIcon: () => {
    //     return <SearchOutlined />;
    //   },
    //   onFilter: (value, record) => {
    //     return record.end_date.toLowerCase().includes(value.toLowerCase());
    //   },
    // },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // sorter: (a, b) => a.status > b.status,
      // filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
      //   return (
      //     <>
      //       <Input
      //         autoFocus
      //         placeholder="Type text here"
      //         value={selectedKeys[0]}
      //         onChange={(e) => {
      //           setSelectedKeys(e.target.value ? [e.target.value] : []);
      //           confirm({ closeDropdown: false });
      //         }}
      //         onBlur={() => {
      //           confirm();
      //         }}
      //       ></Input>
      //     </>
      //   );
      // },
      // filterIcon: () => {
      //   return <SearchOutlined />;
      // },
      // onFilter: (value, record) => {
      //   return record.status.toLowerCase().includes(value.toLowerCase());
      // },
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      align: "center",
      render: (text, record) => {
        console.log(record)
        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "1rem" }}
          >
            {/* <EditOutlined
              style={{ fontSize: "20px", color: "#08c" }}
              onClick={(e) => {
                setOpen(true);
                setEditableData({
                  ...editableData,
                  _id: service.data?.AIServiceSettings?._id,
                  name: service.data?.AIServiceSettings?.serviceName,
                  start: service.data?.AIServiceSettings?.startDate,
                  end: service.data?.AIServiceSettings?.endDate,
                  active: service.data?.AIServiceSettings?.isActive,
                });
              }}
            /> */}
            <Switch
              onChange={editHandling}
              checkedChildren="ON"
              unCheckedChildren="OFF"
              defaultChecked={record?.active}
              disabled={!canToggleAiService}
            />
          </div>
        );
      },
    },
  ];

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  const editHandleDate = (value, dateString) => {
    if (value === null) {
      setDisableEdit({
        ...editableData,
        start: moment(new Date()).format("YYYY-MM-DD"),
        end: moment(new Date()).format("YYYY-MM-DD"),
      });
    } else {
      setEditableData({
        ...editableData,
        start: dateString[0],
        end: dateString[1],
      });
    }
  };

  const createServiceHandler = async (e) => {
    e.preventDefault();
    setLoad(true);
    try {
      const response = await api.post(
        `/AIServiceSettings`,
        {
          serviceName: serviceName,
          startDate: defaultDate[0],
          endDate: defaultDate[1],
          isActive: active,
        },
        {
          tokenType: "user",
        }
      );
      if (response.data.status) {
        getAllServices();
        setServiceName("");
        setActive(null);
        setDisable(true);
      }
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const editHandling = async (checked) => {
    setLoad(true);
    try {
      await api.put(
        `/AIServiceSettings/${editableData._id}`,
        {
          serviceName: editableData.name,
          startDate: editableData.start,
          endDate: editableData.end,
          isActive: checked,
        },
        {
          tokenType: "user",
        }
      );
      getAllServices();
      setOpen(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  const getAllServices = async () => {
    setLoad(true);
    try {
      const service = await api.get(`/AIServiceSettings`, {
        tokenType: "user",
      });
      setEditableData({
        ...editableData,
        _id: service.data?.AIServiceSettings?._id,
        name: service.data?.AIServiceSettings?.serviceName,
        start: service.data?.AIServiceSettings?.startDate,
        end: service.data?.AIServiceSettings?.endDate,
        active: service.data?.AIServiceSettings?.isActive,
      });
      let data = [];
      data.push({
        sno: 1,
        name: service.data?.AIServiceSettings?.serviceName,
        start_date: formatDateDDMMYYYY(
          new Date(service.data?.AIServiceSettings?.startDate)
        ),
        end_date: formatDateDDMMYYYY(
          new Date(service.data?.AIServiceSettings?.endDate)
        ),
        status: service.data?.AIServiceSettings?.isActive ? (
          <Tag color="success">Active</Tag>
        ) : (
          <Tag color="error">In Active</Tag>
        ),
        _id: service.data?.AIServiceSettings?._id,
        active: service.data?.AIServiceSettings?.isActive,
        // action: (
        //   <div
        //     className="d-flex align-items-center justify-content-center"
        //     style={{ gap: "1rem" }}
        //   >
        //     {/* <EditOutlined
        //       style={{ fontSize: "20px", color: "#08c" }}
        //       onClick={(e) => {
        //         setOpen(true);
        //         setEditableData({
        //           ...editableData,
        //           _id: service.data?.AIServiceSettings?._id,
        //           name: service.data?.AIServiceSettings?.serviceName,
        //           start: service.data?.AIServiceSettings?.startDate,
        //           end: service.data?.AIServiceSettings?.endDate,
        //           active: service.data?.AIServiceSettings?.isActive,
        //         });
        //       }}
        //     /> */}
        //     <Switch
        //       onChange={editHandling}
        //       checkedChildren="ON"
        //       unCheckedChildren="OFF"
        //       defaultChecked={editableData?.active}
        //     />
        //   </div>
        // ),
      });
      setTableData([...data]);
      setLoad(false);
    } catch (err) {
      console.log(err);
      setLoad(false);
    }
  };

  useEffect(() => {
    getAllServices();
  }, []);

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  useEffect(() => {
    if (serviceName !== "" && active !== "") {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [serviceName, active]);

  useEffect(() => {
    if (editableData.name !== "" && editableData.active !== "") {
      setDisableEdit(false);
    } else {
      setDisableEdit(true);
    }
  }, [editableData]);

  console.log(editableData);

  if (!canViewAiService) {
    return <div></div>;
  }

  return (
    <Dashboard title="Digital Document">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="row">
        {/* <div className="col-md-12">
          <Card title="Create Services" className="border mt-1">
            <div className="row mb-4">
              <div className="col-md-4">
                <input
                  type="text"
                  className="border form-control"
                  placeholder="Enter Service Name"
                  onChange={(e) => setServiceName(e.target.value)}
                  value={serviceName}
                />
              </div>
              <div className="col-md-3">
                <RangePicker
                  style={{ height: "37px" }}
                  className=""
                  format="YYYY-MM-DD"
                  defaultValue={[
                    moment(new Date(moment(new Date()).format("YYYY-MM-DD"))),
                    moment(
                      new Date(
                        moment(new Date(oneMonthLater)).format("YYYY-MM-DD")
                      )
                    ),
                  ]}
                  onChange={handleDate}
                  // disabledDate={disabledDate}
                  placeholder={[
                    moment(new Date()).format("YYYY-MM-DD"),
                    moment(new Date()).format("YYYY-MM-DD"),
                  ]}
                />
              </div>
              <div className="col-md-3">
                <select
                  id="FormType"
                  className="mb-2 form-control"
                  onChange={(e) => setActive(e.target.value)}
                  value={active}
                >
                  <option value="">Select Service Status</option>
                  <option value={true}>Active</option>
                  <option value={false}>In Active</option>
                </select>
              </div>
              <div className="text-center col-md-2">
                <button
                  className={`btn ${
                    !disable ? "btn-primary" : "btn-secondary"
                  }`}
                  type="submit"
                  onClick={createServiceHandler}
                  disabled={disable}
                >
                  Submit
                </button>
              </div>
            </div>
          </Card>
        </div> */}
        <div className="col-md-12 mb-4">
          <Card title="AI Service" className="border mt-3">
            <div style={{ width: "100%" }}>
              <Table
                columns={columns}
                dataSource={tableData}
                pagination={{
                  total: 0,
                  pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
                  showSizeChanger: false,
                }}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre" }}
              />
            </div>
          </Card>
        </div>
        <Modal
          title="Edit Service"
          centered
          open={open}
          footer={false}
          onOk={() => {
            setEditableData({
              _id: "",
              name: "",
              start: "",
              end: "",
              active: "",
            });
            setOpen(false);
          }}
          onCancel={() => {
            setEditableData({
              _id: "",
              name: "",
              start: "",
              end: "",
              active: "",
            });
            setOpen(false);
          }}
          width={500}
        >
          <div className="row">
            <div className="col-md-12">
              <div className="row mb-4">
                <div className="col-md-12 mb-4">
                  <RangePicker
                    style={{ height: "37px", width: "100%" }}
                    className=""
                    format="YYYY-MM-DD"
                    value={[
                      moment(
                        new Date(
                          moment(new Date(editableData.start)).format(
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                      moment(
                        new Date(
                          moment(new Date(editableData.end)).format(
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                    ]}
                    onChange={editHandleDate}
                  />
                </div>
                <div className="col-md-12">
                  <select
                    id="FormType"
                    className="mb-2 form-control"
                    value={editableData.active}
                    onChange={(e) =>
                      setEditableData({
                        ...editableData,
                        active: e.target.value,
                      })
                    }
                  >
                    <option value="">Select Service Status</option>
                    <option value={true}>Active</option>
                    <option value={false}>In Active</option>
                  </select>
                </div>
              </div>
              <input
                type="text"
                className="border form-control"
                placeholder="Enter Service Name"
                onChange={(e) =>
                  setEditableData({
                    ...editableData,
                    name: e.target.value,
                  })
                }
                value={editableData.name}
              />
              <div className="text-center">
                <button
                  className={`btn mt-4 ${
                    !disableEdit && canToggleAiService ? "btn-primary" : "btn-secondary"
                  }`}
                  type="submit"
                  onClick={editHandling}
                  disabled={disableEdit || !canToggleAiService}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Dashboard>
  );
};

export default AIService;
